import dynamic from 'next/dynamic'

export const PRODUCT_WIDGETS_VS_COMPONENTS = {
  'travel-seo-widget': dynamic(() => import('@components/MainWidget/Travel/TravelMainSeoWidget')),
  'health-seo-widget': dynamic(() => import('@components/MainWidget/Health/healthSeoWidget')),
  'life-seo-widget': dynamic(() => import('@components/MainWidget/LifeWidget/LifeWidget')),
  'travel-sem-widget': dynamic(() => import('@components/MainWidget/Travel/Sem/TravelMainSemWidget')),
  'car-seo-widget': dynamic(() => import('@components/MainWidget/Car/carWidget')),
  'bike-seo-widget': dynamic(() => import('@components/MainWidget/Bike/bikeWidget')),
  'fastag-widget': dynamic(() => import('@components/MainWidget/FastagWidget/fastagWidget')),
  'puc-widget': dynamic(() => import('@components/MainWidget/Puc/pucWidget')),
  'abha-seo-widget': dynamic(() => import('@components/MainWidget/Abha/abhaWidget')),
  'multi-product-widget': dynamic(() => import('@components/MainWidget/CarBikeInTab/MultiProductWidget')),
  'gmc-cta-widget': dynamic(() => import('@components/MainWidget/CtaWidgetPurpleVariant/DynamicCta')),
  'health-cta-widget': dynamic(() => import('@components/MainWidget/CtaWidgetPurpleVariant/DynamicCta')),
  'travel-cta-widget': dynamic(() => import('@components/MainWidget/CtaWidgetPurpleVariant/DynamicCta')),
  'life-cta-widget': dynamic(() => import('@components/MainWidget/CtaWidgetPurpleVariant/DynamicCta')),
  'rto-vehicle-info-widget': dynamic(() => import('@components/MainWidget/RtoVehicleInfo/rtoVehicleInfoWidget')),
  'rto-widget': dynamic(() => import('@components/MainWidget/RtoDetail/rtoDetailWidget')),
  'challan-widget': dynamic(() => import('@components/MainWidget/ChallanWidget/challanWidget')),
  'challan-widget-landing-page': dynamic(
    () => import('@components/MainWidget/ChallanWidgetLanding/ChallanWidgetLanding')
  ),
  'fastag-widget-landing-page': dynamic(() => import('@components/MainWidget/FastagWidgetLanding/fastagWidgetLanding')),
  'hsrp-widget-landing-page': dynamic(() => import('@components/MainWidget/HsrpWidgetLanding/hsrpWidgetLanding')),
  RTOWidget: dynamic(() => import('@components/MainWidget/ChallanWidgetLanding/ChallanWidgetLanding')),
}
